"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBidDto = instanceOfBidDto;
exports.BidDtoFromJSON = BidDtoFromJSON;
exports.BidDtoFromJSONTyped = BidDtoFromJSONTyped;
exports.BidDtoToJSON = BidDtoToJSON;
exports.BidDtoToJSONTyped = BidDtoToJSONTyped;
/**
 * Check if a given object implements the BidDto interface.
 */
function instanceOfBidDto(value) {
    if (!('bidAmount' in value) || value['bidAmount'] === undefined)
        return false;
    return true;
}
function BidDtoFromJSON(json) {
    return BidDtoFromJSONTyped(json, false);
}
function BidDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'bidAmount': json['bidAmount'],
    };
}
function BidDtoToJSON(json) {
    return BidDtoToJSONTyped(json, false);
}
function BidDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'bidAmount': value['bidAmount'],
    };
}
